<div class="filters-wrapper" [formGroup]="filtersForm">
  <p class="ui-label-m-bold c-800-shade-blue mb-3">Date Range</p>
  <div class="controls-wrapper">
    <rds-form-field labelPosition="none" size="m">
      <input
        rdsInput
        [rdsDatepicker]="datePickerFrom"
        formControlName="fromDate"
        placeholder="From date" />
      <rds-datepicker-toggle rds-control-suffix />
      <rds-datepicker #datePickerFrom></rds-datepicker>
    </rds-form-field>
    <rds-form-field labelPosition="none" size="m">
      <input
        rdsInput
        [rdsDatepicker]="datePickerTo"
        formControlName="toDate"
        placeholder="To date" />
      <rds-datepicker-toggle rds-control-suffix />
      <rds-datepicker #datePickerTo></rds-datepicker>
    </rds-form-field>
  </div>

  <div class="select-controls-wrapper mt-3">
    <p class="ui-label-m-bold c-800-shade-blue mb-3">Year</p>
    <rds-form-field labelPosition="none" size="m">
      <rds-select placeholder="Select year" formControlName="year">
        <rds-select-option [value]="null">All years</rds-select-option>
        @for (year of years; track year) {
          <rds-select-option [value]="year">{{ year }}</rds-select-option>
        }
      </rds-select>
    </rds-form-field>

    <p class="ui-label-m-bold c-800-shade-blue mb-3">Month</p>
    <rds-form-field labelPosition="none" size="m">
      <rds-select placeholder="Select month" formControlName="month">
        @for (entry of months; track entry.value) {
          <rds-select-option [value]="entry.value">{{
            entry.name
          }}</rds-select-option>
        }
      </rds-select>
    </rds-form-field>

    <p class="ui-label-m-bold c-800-shade-blue mb-3">Quarter</p>
    <rds-form-field labelPosition="none" size="m">
      <rds-select placeholder="Select quarter" formControlName="quarter">
        @for (i of [].constructor(4); track index; let index = $index) {
          <rds-select-option [value]="index + 1">{{
            'Q' + (index + 1)
          }}</rds-select-option>
        }
      </rds-select>
    </rds-form-field>

    <p class="ui-label-m-bold c-800-shade-blue mb-3">Week number</p>
    <rds-form-field labelPosition="none" size="m">
      <rds-select placeholder="Select week number" formControlName="weekNumber">
        @for (i of [].constructor(53); track index; let index = $index) {
          <rds-select-option [value]="index + 1">{{
            index + 1
          }}</rds-select-option>
        }
      </rds-select>
    </rds-form-field>
  </div>
</div>

@if (isMobileScreen()) {
  <div class="button-section">
    <button rds-secondary-button size="m" (click)="resetForm()">
      Clear All
    </button>
    <button rds-primary-button size="m" (click)="applyFilters()">Apply</button>
  </div>
} @else {
  <div class="clear-button">
    <button rds-secondary-button size="m" (click)="resetForm()">
      Clear All
    </button>
  </div>
}
